import React from "react"
import LazyHero from "react-lazy-hero"
import { Container } from "reactstrap"
import DataImgSrc from "./imgs/data.jpg"
import LoginPage from "./Login"
import { useAuth0 } from "@auth0/auth0-react"

const DataImage = () => {
  return (
    <div className="hero-img-padding-top">
      <LazyHero
        color={"white"}
        opacity={0.2}
        imageSrc={DataImgSrc}
        minHeight={"30vh"}
      />
    </div>
  )
}
function HomePage() {
  const { isAuthenticated } = useAuth0()
  return (
    <div>
      <DataImage />
      <Container className="home-top-padding text-center">
        <h1>Health Declaration Forms: Made Easier</h1>
        <h3>Contactless. Paperless.</h3>
        {isAuthenticated ? window.location.replace("/admin") : <LoginPage />}
      </Container>
    </div>
  )
}

export default HomePage
